<template>
  <div>
    <ModalComponent
      ref="modal"
      class="[&_.boxComponent]:bg-transparent [&_.boxComponent]:bg-none [&_.boxComponent_*]:p-0"
    >
      <div class="w-full h-[75dvh] mb-8 relative rounded-2xl flex">
        <div class="flex items-center relative">
          <img
            :src="coupon.pictureUrl"
            alt=""
            class="w-full h-full object-contain object-center rounded-2xl overflow-hidden ticket"
            style=""
          />
          <!-- <div class="absolute w-full left-0">
            <div class="ticketRip">
              <div class="circleLeft !bg-[#191F29]"></div>
              <div class="circleRight !bg-[#234067]"></div>
            </div>
          </div> -->
        </div>
        <div class="absolute -bottom-6 flex justify-center w-full">
          <button
            @click="$Commons.copy(coupon.code, $t('coupons.codeCopied'))"
            class="buttonComponent flex !px-4 !py-2 items-center gap-4"
          >
            <div>
              {{
                $t('coupons.copyButtonText', {
                  code: coupon.code,
                  bookmaker: coupon.bookmaker || '',
                })
              }}
            </div>
            <div class="w-6 h-6">
              <img src="@/assets/images/all/copy-white.svg" alt="" />
            </div>
          </button>
        </div>
      </div>
    </ModalComponent>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '@/components/utils/ModalComponent.vue'

export default defineComponent({
  name: 'CouponDetails',
  components: { ModalComponent },
  props: {},
  data() {
    return {
      coupon: {},
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'show_coupon_requested',
      this.showCoupon,
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    showCoupon(coupon) {
      this.coupon = coupon
      this.$refs.modal.show()
    },
  },
  computed: {},
})
</script>
